<template>
  <div>
    <div class="consumer">
      <div class="left_list_title">
        <span>消费者客群结构</span>
      </div>
      <div class="consumer_1">
        <!-- <div class="subtitle">{{ consumer_struct.dataList[0].name }}</div> -->
        <div class="subtitle">上一季度消费客群来源构成</div>
        <div class="consumer_pic_wrapper">
          <div class="consumer_pic" id="syjdxfkqlygc"></div>
        </div>
        <div class="consumer_note">
          <div class="consumer_note_box bg_col1"></div>
          <div class="consumer_note_txt">{{ dataList1[0].name }}</div>
        </div>
        <div class="consumer_note">
          <div class="consumer_note_box bg_col2"></div>
          <div class="consumer_note_txt">{{ dataList1[1].name }}</div>
        </div>
      </div>
      <div class="consumer_1">
        <!-- <div class="subtitle">{{ consumer_struct.dataList[1].name }}</div> -->
        <div class="subtitle">上一季度消费客群性别构成</div>
        <div class="consumer_pic_wrapper">
          <div class="consumer_pic" id="syjdxfkqxbgc"></div>
        </div>
        <div class="consumer_note">
          <div class="consumer_note_box bg_col3"></div>
          <div class="consumer_note_txt">{{ dataList2[0].name }}</div>
        </div>
        <div class="consumer_note">
          <div class="consumer_note_box bg_col4"></div>
          <div class="consumer_note_txt">{{ dataList2[1].name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Highcharts from "highcharts/highstock";
import HighchartsMore from "highcharts/highcharts-more";
import HighchartsDrilldown from "highcharts/modules/drilldown";
import Highcharts3D from "highcharts/highcharts-3d";
HighchartsMore(Highcharts);
HighchartsDrilldown(Highcharts);
Highcharts3D(Highcharts);
export default {
  data() {
    return {
      // 上一季度消费客群来源构成
      dataList1: [
        {
          name: "日均外地消费人次",
          y: 600,
          h: 0,
          bfb: 0,
          bl: "50",
        },
        {
          name: "日均本地消费人次",
          y: 200,
          h: 0,
          bfb: 0,
          bl: "50",
        },
      ],
      // 上一季度消费客群性别构成
      dataList2: [
        {
          name: "日均男性消费人次",
          y: 100,
          h: 0,
          bfb: 0,
          bl: "50",
        },
        {
          name: "日均女性消费人次",
          y: 400,
          h: 0,
          bfb: 0,
          bl: "50",
        },
      ],
    };
  },
  props: {
    consumer_struct: {
      typeof: Array,
      default: () => [],
    },
  },
  watch: {
    consumer_struct: {
      deep: true,
      handler: function (newV, oldV) {
        this.getData();
      },
    },
    dataList1() {
      this.$nextTick(() => {
        this.initOption1();
      });
    },
    dataList2() {
      this.$nextTick(() => {
        this.initOption2();
      });
    },
  },
  mounted() {
    this.initOption1();
    window.addEventListener("resize", this.initOption1);

    this.initOption2();
    window.addEventListener("resize", this.initOption2);
  },
  destroyed() {
    window.removeEventListener("resize", this.initOption1);
    window.removeEventListener("resize", this.initOption2);
  },
  methods: {
    getData() {
        for (
          let index = 0;
          index < 2;
          index++
        ) {
          const element = this.consumer_struct[index];
          if (element.type == "source") {
            for (let i = 0; i < 2; i++) {
              const e = element.data[i];
              this.dataList1[i].name = e.label;
              this.dataList1[i].y = Number(e.value);
              this.dataList1[i].bl = Number(e.proportion);
            }
            this.initOption1();
          }
          if (element.type == "sex") {
            for (let i = 0; i < 2; i++) {
              const e = element.data[i];
              this.dataList2[i].name = e.label;
              this.dataList2[i].y = Number(e.value);
              this.dataList2[i].bl = Number(e.proportion);
            }
            this.initOption2();
          }
      }
    },
    initOption1() {
      let quantity = 0; // 总数
      this.dataList1.forEach((item) => {
        quantity += item.y;
      });
      this.dataList1.forEach((item) => {
        item.bfb = parseInt((item.y / quantity) * 100);
        item.h = item.bfb * 1.5 >= 70 ? 10 : 15;
        // item.h = parseInt(0.86 * item.bfb); // 最高高度60，根据比例渲染高度
        // console.log(this.dataList1, "dataList1----->>>");
      });
      // 修改3d饼图绘制过程
      var each = Highcharts.each,
        round = Math.round,
        cos = Math.cos,
        sin = Math.sin,
        deg2rad = Math.deg2rad;
      Highcharts.wrap(
        Highcharts.seriesTypes.pie.prototype,
        "translate",
        function (proceed) {
          proceed.apply(this, [].slice.call(arguments, 1));
          // Do not do this if the chart is not 3D
          if (!this.chart.is3d()) {
            return;
          }
          var series = this,
            chart = series.chart,
            options = chart.options,
            seriesOptions = series.options,
            depth = seriesOptions.depth || 0,
            options3d = options.chart.options3d,
            alpha = options3d.alpha,
            beta = options3d.beta,
            z = seriesOptions.stacking
              ? (seriesOptions.stack || 0) * depth
              : series._i * depth;
          z += depth / 2;
          if (seriesOptions.grouping !== false) {
            z = 0;
          }
          each(series.data, function (point) {
            var shapeArgs = point.shapeArgs,
              angle;
            point.shapeType = "arc3d";
            var ran = point.options.h;
            shapeArgs.z = z;
            shapeArgs.depth = depth * 0.75 + ran;
            shapeArgs.alpha = alpha;
            shapeArgs.beta = beta;
            shapeArgs.center = series.center;
            shapeArgs.ran = ran;
            angle = (shapeArgs.end + shapeArgs.start) / 2;
            point.slicedTranslation = {
              translateX: round(
                cos(angle) * seriesOptions.slicedOffset * cos(alpha * deg2rad)
              ),
              translateY: round(
                sin(angle) * seriesOptions.slicedOffset * cos(alpha * deg2rad)
              ),
            };
          });
        }
      );
      (function (H) {
        H.wrap(
          Highcharts.SVGRenderer.prototype,
          "arc3dPath",
          function (proceed) {
            // Run original proceed method
            var ret = proceed.apply(this, [].slice.call(arguments, 1));
            ret.zTop = (ret.zOut + 0.5) / 100;
            return ret;
          }
        );
      })(Highcharts);
      Highcharts.chart("syjdxfkqlygc", {
        chart: {
          animation: false,
          backgroundColor: "none",
          type: "pie", //饼图
          options3d: {
            enabled: true, //使用3d功能
            alpha: 70, //延y轴向内的倾斜角度
            beta: 0,
          },
          events: {
            load: function () {
              var each = Highcharts.each,
                points = this.series[0].points;
              each(points, function (p, i) {
                p.graphic.attr({
                  translateY: -p.shapeArgs.ran,
                });
                p.graphic.side1.attr({
                  translateY: -p.shapeArgs.ran,
                });
                p.graphic.side2.attr({
                  translateY: -p.shapeArgs.ran,
                });
              });
            },
          },
        },
        legend: {
          enabled: false, // 关闭图例
        },
        title: {
          text: this.dataList1[0].bl + "%",
          x: 0,
          y: 90,
          style: {
            color: "#ffffff",
            fontSize: 24,
          },
        },
        subtitle: {
          text: this.dataList1[0].name+"占比",
          verticalAlign: "bottom",
          x: 0,
          y: -25,
          style: {
            color: "#c8dfe7",
            fontSize: 16,
          },
        },
        plotOptions: {
          pie: {
            allowPointSelect: false, // 禁用点击
            cursor: "pointer",
            depth: 10,
            showInLegend: true,
            size: 300, // 设置饼图大小
            innerSize: 250, // 内圈直径大小
            colors: ["#3950f9", "#38f1f1"],
            dataLabels: {
              useHTML: false,
              enabled: false, //是否显示饼图的线形tip
              distance: 5,
              borderColor: "#007acc",
              align: "center",
              // verticalAlign: 'top',
              position: "right",
              format: "{point.bfb}%",
              color: "#ffffff",
              style: {
                textOutline: "none",
                // fontSize: fontChart(13),
              },
            },
          },
        },
        credits: {
          enabled: false, // 禁用版权信息
        },
        series: [
          {
            type: "pie",
            name: "数量",
            data: this.dataList1,
          },
        ],
      });
    },
    initOption2() {
      let quantity = 0; // 总数
      this.dataList2.forEach((item) => {
        quantity += item.y;
      });
      this.dataList2.forEach((item) => {
        item.bfb = parseInt((item.y / quantity) * 100);
        item.h = item.bfb * 1.5 >= 70 ? 10 : 15;
        // item.h = parseInt(0.86 * item.bfb); // 最高高度60，根据比例渲染高度
        // console.log(this.dataList1, "dataList1----->>>");
      });
      // 修改3d饼图绘制过程
      var each = Highcharts.each,
        round = Math.round,
        cos = Math.cos,
        sin = Math.sin,
        deg2rad = Math.deg2rad;
      Highcharts.wrap(
        Highcharts.seriesTypes.pie.prototype,
        "translate",
        function (proceed) {
          proceed.apply(this, [].slice.call(arguments, 1));
          // Do not do this if the chart is not 3D
          if (!this.chart.is3d()) {
            return;
          }
          var series = this,
            chart = series.chart,
            options = chart.options,
            seriesOptions = series.options,
            depth = seriesOptions.depth || 0,
            options3d = options.chart.options3d,
            alpha = options3d.alpha,
            beta = options3d.beta,
            z = seriesOptions.stacking
              ? (seriesOptions.stack || 0) * depth
              : series._i * depth;
          z += depth / 2;
          if (seriesOptions.grouping !== false) {
            z = 0;
          }
          each(series.data, function (point) {
            var shapeArgs = point.shapeArgs,
              angle;
            point.shapeType = "arc3d";
            var ran = point.options.h;
            shapeArgs.z = z;
            shapeArgs.depth = depth * 0.75 + ran;
            shapeArgs.alpha = alpha;
            shapeArgs.beta = beta;
            shapeArgs.center = series.center;
            shapeArgs.ran = ran;
            angle = (shapeArgs.end + shapeArgs.start) / 2;
            point.slicedTranslation = {
              translateX: round(
                cos(angle) * seriesOptions.slicedOffset * cos(alpha * deg2rad)
              ),
              translateY: round(
                sin(angle) * seriesOptions.slicedOffset * cos(alpha * deg2rad)
              ),
            };
          });
        }
      );
      (function (H) {
        H.wrap(
          Highcharts.SVGRenderer.prototype,
          "arc3dPath",
          function (proceed) {
            // Run original proceed method
            var ret = proceed.apply(this, [].slice.call(arguments, 1));
            ret.zTop = (ret.zOut + 0.5) / 100;
            return ret;
          }
        );
      })(Highcharts);
      Highcharts.chart("syjdxfkqxbgc", {
        chart: {
          animation: false,
          backgroundColor: "none",
          type: "pie", //饼图
          options3d: {
            enabled: true, //使用3d功能
            alpha: 70, //延y轴向内的倾斜角度
            beta: 0,
          },
          events: {
            load: function () {
              var each = Highcharts.each,
                points = this.series[0].points;
              each(points, function (p, i) {
                p.graphic.attr({
                  translateY: -p.shapeArgs.ran,
                });
                p.graphic.side1.attr({
                  translateY: -p.shapeArgs.ran,
                });
                p.graphic.side2.attr({
                  translateY: -p.shapeArgs.ran,
                });
              });
            },
          },
        },
        legend: {
          enabled: false, // 关闭图例
        },
        title: {
          text: this.dataList2[0].bl + "%",
          x: 0,
          y: 90,
          style: {
            color: "#ffffff",
            fontSize: 24,
          },
        },
        subtitle: {
          text: this.dataList2[0].name+"占比",
          verticalAlign: "bottom",
          x: 0,
          y: -25,
          style: {
            color: "#c8dfe7",
            fontSize: 18,
          },
        },
        plotOptions: {
          pie: {
            allowPointSelect: false, // 禁用点击
            cursor: "pointer",
            depth: 10,
            showInLegend: true,
            size: 300, // 设置饼图大小
            innerSize: 250, // 内圈直径大小
            colors: ["#fad900", "#5deab2"],
            dataLabels: {
              useHTML: false,
              enabled: false, //是否显示饼图的线形tip
              distance: 5,
              borderColor: "#007acc",
              align: "center",
              // verticalAlign: 'top',
              position: "right",
              format: "{point.bfb}%",
              color: "#ffffff",
              style: {
                textOutline: "none",
              },
            },
          },
        },
        credits: {
          enabled: false, // 禁用版权信息
        },
        series: [
          {
            type: "pie",
            name: "数量",
            data: this.dataList2,
          },
        ],
      });
    },
  },
};
</script>
<style scoped src="@/assets/css/index3.css">
</style>